import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import { masterExternalIdentificationProviderListApiCall } from "../../../../helpers/fakebackend_helper";
import SettingsPanel from "../../components/SettingsPanel";
import { toast } from "react-toastify";
import DeleteModal from "../../../../Components/Common/DeleteModal";

import {
  createCustomerStatus,
  createCustomerStatusSuccess,
  createCustomerType,
  createCustomerTypeSuccess,
  createCustomerURLLinkStatus,
  createCustomerURLLinkStatusSuccess,
  createCustomerURLLinkType,
  createCustomerURLLinkTypeSuccess,
  createSingleCustomerExternalIDsExternalIdentificationProvider,
  createSingleCustomerExternalIDsExternalIdentificationProviderSuccess,
  deleteCustomerStatus,
  deleteCustomerStatusSuccess,
  deleteCustomerType,
  deleteCustomerTypeSuccess,
  deleteCustomerURLLinkStatus,
  deleteCustomerURLLinkStatusSuccess,
  deleteCustomerURLLinkType,
  deleteCustomerURLLinkTypeSuccess,
  deleteSingleCustomerExternalIDsExternalIdentificationProvider,
  deleteSingleCustomerExternalIDsExternalIdentificationProviderSuccess,
  getCustomerStatusListData,
  getCustomerTypeListData,
  getCustomerURLLinkStatusListData,
  getCustomerURLLinkTypeListData,
  getSingleCustomerExternalIDsExternalIdentificationProviderDetails,
  getSingleCustomerExternalIDsExternalIdentificationProviderListData,
  updateCustomerStatus,
  updateCustomerStatusSuccess,
  updateCustomerType,
  updateCustomerTypeSuccess,
  updateCustomerURLLinkStatus,
  updateCustomerURLLinkStatusSuccess,
  updateCustomerURLLinkType,
  updateCustomerURLLinkTypeSuccess,
  updateSingleCustomerExternalIDsExternalIdentificationProvider,
  updateSingleCustomerExternalIDsExternalIdentificationProviderSuccess,
} from "../../../../store/customers/action";

import {
  createAcquisitionChannel,
  createAcquisitionChannelSuccess,
  deleteAcquisitionChannel,
  deleteAcquisitionChannelSuccess,
  getAcquisitionChannelList,
  updateAcquisitionChannel,
  updateAcquisitionChannelSuccess,
} from "../../../../store/customerAcquisitionChannel/action";

export default function CustomerSettings() {
  const dispatch = useDispatch();

  const {
    customerUrlLinkStatusListAPI,
    customerUrlLinkTypeListAPI,
    acquisitionChannelListAPI,
    singleCustomerExternalIdsExternalIdentificationProviderListAPI,
    customerStatusListAPI,
    customerTypeListAPI,
  } = useSelector((state) => ({
    customerUrlLinkStatusListAPI:
      state.Customers.customerUrlLinkStatusList?.customerurllinkstatus_list,
    customerUrlLinkTypeListAPI:
      state.Customers.customerUrlLinkTypeList?.customerurllinktype_list,
    acquisitionChannelListAPI:
      state.CustomerAcquisitionChannel?.acquisitionChannelList
        ?.customeracquisitionchannel_list,
    singleCustomerExternalIdsExternalIdentificationProviderListAPI:
      state.Customers
        .singleCustomerExternalIdsExternalIdentificationProviderList
        ?.externalidentificationprovider_list,
    customerStatusListAPI:
      state.Customers.customerStatusList?.customerstatus_list,
    customerTypeListAPI: state.Customers.customerTypeList?.customertype_list,
  }));

  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
  });

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      // Task Status create
      dispatch(createCustomerURLLinkStatus([createStatus]));
    }
    if (activeTab === "2") {
      // Task Type create
      dispatch(createCustomerURLLinkType([createStatus]));
    }
    if (activeTab === "3") {
      // Acquisition Channel create
      dispatch(createAcquisitionChannel([createStatus]));
    }
    if (activeTab === "4") {
      // External Identification Provider create
      dispatch(
        createSingleCustomerExternalIDsExternalIdentificationProvider([
          createStatus,
        ])
      );
    }
    if (activeTab === "5") {
      // Customer Status create
      dispatch(createCustomerStatus([createStatus]));
    }
    if (activeTab === "6") {
      // Customer Status create
      dispatch(createCustomerType([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = customerUrlLinkStatusListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "2") {
      data = customerUrlLinkTypeListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "3") {
      data = acquisitionChannelListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "4") {
      data =
        singleCustomerExternalIdsExternalIdentificationProviderListAPI?.sort(
          (a, b) => b.Id - a.Id
        );
    }

    if (activeTab === "5") {
      data = customerStatusListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "6") {
      data = customerTypeListAPI?.sort((a, b) => b.Id - a.Id);
    }

    setStatusList(data);
  }, [
    customerUrlLinkStatusListAPI,
    customerUrlLinkTypeListAPI,
    acquisitionChannelListAPI,
    singleCustomerExternalIdsExternalIdentificationProviderListAPI,
    customerStatusListAPI,
    customerTypeListAPI,
    activeTab,
  ]);

  useEffect(() => {
    dispatch(getCustomerURLLinkStatusListData());
    dispatch(getCustomerURLLinkTypeListData());
    dispatch(getAcquisitionChannelList());
    dispatch(getCustomerStatusListData());
    dispatch(getCustomerTypeListData());
    // Tab 4 (External Identification Provider) - its list was never fetched,
    // so the provider list showed empty. Load it here too.
    dispatch(getSingleCustomerExternalIDsExternalIdentificationProviderListData());
  }, []);

  // Master provider catalogue - lets each company provider (tab 4) be mapped to
  // the master list via MasterExternalIdentificationProvider_Id.
  const [masterProvidersList, setMasterProvidersList] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const response = await masterExternalIdentificationProviderListApiCall();
        setMasterProvidersList(
          response?.masterexternalidentificationprovider_list || []
        );
      } catch (e) {
        // non-fatal; the map dropdown will just be empty
      }
    })();
  }, []);

  const Tabs = [
    {
      id: "1",
      name: "URL Link Status",
    },
    {
      id: "2",
      name: "URL Link Type",
    },
    {
      id: "3",
      name: "Acquisition Channel",
    },
    {
      id: "4",
      name: "External Identification Provider",
    },
    {
      id: "5",
      name: "Status",
    },
    {
      id: "6",
      name: "Type",
    },
  ];
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //  Task Status delete

      dispatch(deleteCustomerURLLinkStatus([deleteStatus]));
    }
    if (activeTab === "2") {
      // Task Type delete
      dispatch(deleteCustomerURLLinkType([deleteStatus]));
    }
    if (activeTab === "3") {
      // Acquisition Channel delete
      dispatch(deleteAcquisitionChannel([deleteStatus]));
    }
    if (activeTab === "4") {
      // External Identification Provider delete
      dispatch(
        deleteSingleCustomerExternalIDsExternalIdentificationProvider([
          deleteStatus,
        ])
      );
    }
    if (activeTab === "5") {
      // Acquisition Channel delete
      dispatch(deleteCustomerStatus([deleteStatus]));
    }
    if (activeTab === "6") {
      // Acquisition Channel delete
      dispatch(deleteCustomerType([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
    };
    // Tab 4: persist the master-provider mapping when set.
    if (updateItemStatus?.MasterExternalIdentificationProvider_Id !== undefined) {
      updateNewStatus.MasterExternalIdentificationProvider_Id =
        updateItemStatus.MasterExternalIdentificationProvider_Id;
    }
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        // Task Status update

        dispatch(updateCustomerURLLinkStatus([updateNewStatus]));
      }
      if (activeTab === "2") {
        // Task Type update
        dispatch(updateCustomerURLLinkType([updateNewStatus]));
      }
      if (activeTab === "3") {
        // Acquisition Channel update
        dispatch(updateAcquisitionChannel([updateNewStatus]));
      }
      if (activeTab === "4") {
        // External Identification Provider update
        dispatch(
          updateSingleCustomerExternalIDsExternalIdentificationProvider([
            updateNewStatus,
          ])
        );
      }
      if (activeTab === "5") {
        // Acquisition Channel update
        dispatch(updateCustomerStatus([updateNewStatus]));
      }
      if (activeTab === "6") {
        // Acquisition Channel update
        dispatch(updateCustomerType([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  const {
    createCustomerUrlLinkStatusResponseAPI,
    updateCustomerUrlLinkStatusResponseAPI,
    deleteCustomerUrlLinkStatusResponseAPI,
    createCustomerUrlLinkTypeResponseAPI,
    updateCustomerUrlLinkTypeResponseAPI,
    deleteCustomerUrlLinkTypeResponseAPI,
    createAcquisitionChannelSuccessAPI,
    updateAcquisitionChannelSuccessAPI,
    deleteAcquisitionChannelSuccessAPI,
    createSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI,
    updateSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI,
    deleteSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI,
    createCustomerStatusResponseAPI,
    updateCustomerStatusResponseAPI,
    deleteCustomerStatusResponseAPI,
    createCustomerTypeResponseAPI,
    updateCustomerTypeResponseAPI,
    deleteCustomerTypeResponseAPI,
  } = useSelector((state) => ({
    createCustomerUrlLinkStatusResponseAPI:
      state.Customers.createCustomerUrlLinkStatusResponse,
    updateCustomerUrlLinkStatusResponseAPI:
      state.Customers.updateCustomerUrlLinkStatusResponse,
    deleteCustomerUrlLinkStatusResponseAPI:
      state.Customers.deleteCustomerUrlLinkStatusResponse,
    createCustomerUrlLinkTypeResponseAPI:
      state.Customers.createCustomerUrlLinkTypeResponse,
    updateCustomerUrlLinkTypeResponseAPI:
      state.Customers.updateCustomerUrlLinkTypeResponse,
    deleteCustomerUrlLinkTypeResponseAPI:
      state.Customers.deleteCustomerUrlLinkTypeResponse,
    createAcquisitionChannelSuccessAPI:
      state.CustomerAcquisitionChannel.createAcquisitionChannelSuccess,
    updateAcquisitionChannelSuccessAPI:
      state.CustomerAcquisitionChannel.updateAcquisitionChannelSuccess,
    deleteAcquisitionChannelSuccessAPI:
      state.CustomerAcquisitionChannel.deleteAcquisitionChannelSuccess,
    createSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI:
      state.Customers
        .createSingleCustomerExternalIdsExternalIdentificationProviderResponse,
    updateSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI:
      state.Customers
        .updateSingleCustomerExternalIdsExternalIdentificationProviderResponse,
    deleteSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI:
      state.Customers
        .deleteSingleCustomerExternalIdsExternalIdentificationProviderResponse,
    createCustomerStatusResponseAPI:
      state.Customers.createCustomerStatusResponse,
    updateCustomerStatusResponseAPI:
      state.Customers.updateCustomerStatusResponse,
    deleteCustomerStatusResponseAPI:
      state.Customers.deleteCustomerStatusResponse,
    createCustomerTypeResponseAPI: state.Customers.createCustomerTypeResponse,
    updateCustomerTypeResponseAPI: state.Customers.updateCustomerTypeResponse,
    deleteCustomerTypeResponseAPI: state.Customers.deleteCustomerTypeResponse,
  }));

  //Create Customer Url Link Status response
  useEffect(() => {
    if (isEmpty(createCustomerUrlLinkStatusResponseAPI)) return;
    if (createCustomerUrlLinkStatusResponseAPI?.status === 200) {
      toast.success(createCustomerUrlLinkStatusResponseAPI?.message);
      dispatch(getCustomerURLLinkStatusListData());
    } else {
      toast.error(createCustomerUrlLinkStatusResponseAPI?.message);
    }
    dispatch(createCustomerURLLinkStatusSuccess([]));
  }, [createCustomerUrlLinkStatusResponseAPI]);

  //Update Customer Url Link Status response
  useEffect(() => {
    if (isEmpty(updateCustomerUrlLinkStatusResponseAPI)) return;
    if (updateCustomerUrlLinkStatusResponseAPI?.status === 200) {
      toast.success(updateCustomerUrlLinkStatusResponseAPI?.message);
      dispatch(getCustomerURLLinkStatusListData());
    } else {
      toast.error(updateCustomerUrlLinkStatusResponseAPI?.message);
    }
    dispatch(updateCustomerURLLinkStatusSuccess([]));
  }, [updateCustomerUrlLinkStatusResponseAPI]);

  //Delete Customer Url Link Status response
  useEffect(() => {
    if (isEmpty(deleteCustomerUrlLinkStatusResponseAPI)) return;
    if (deleteCustomerUrlLinkStatusResponseAPI?.status === 200) {
      toast.success(deleteCustomerUrlLinkStatusResponseAPI?.message);
      dispatch(getCustomerURLLinkStatusListData());
      setDeleteModal(false);
    } else {
      toast.error(deleteCustomerUrlLinkStatusResponseAPI?.message);
    }
    dispatch(deleteCustomerURLLinkStatusSuccess([]));
  }, [deleteCustomerUrlLinkStatusResponseAPI]);

  //Create Customer Url Link Type response
  useEffect(() => {
    if (isEmpty(createCustomerUrlLinkTypeResponseAPI)) return;
    if (createCustomerUrlLinkTypeResponseAPI?.status === 200) {
      toast.success(createCustomerUrlLinkTypeResponseAPI?.message);
      dispatch(getCustomerURLLinkTypeListData());
    } else {
      toast.error(createCustomerUrlLinkTypeResponseAPI?.message);
    }
    dispatch(createCustomerURLLinkTypeSuccess([]));
  }, [createCustomerUrlLinkTypeResponseAPI]);

  //Update Customer Url Link Type response
  useEffect(() => {
    if (isEmpty(updateCustomerUrlLinkTypeResponseAPI)) return;
    if (updateCustomerUrlLinkTypeResponseAPI?.status === 200) {
      toast.success(updateCustomerUrlLinkTypeResponseAPI?.message);
      dispatch(getCustomerURLLinkTypeListData());
    } else {
      toast.error(updateCustomerUrlLinkTypeResponseAPI?.message);
    }
    dispatch(updateCustomerURLLinkTypeSuccess([]));
  }, [updateCustomerUrlLinkTypeResponseAPI]);

  //Delete Customer Url Link Type response
  useEffect(() => {
    if (isEmpty(deleteCustomerUrlLinkTypeResponseAPI)) return;
    if (deleteCustomerUrlLinkTypeResponseAPI?.status === 200) {
      toast.success(deleteCustomerUrlLinkTypeResponseAPI?.message);
      dispatch(getCustomerURLLinkTypeListData());
      setDeleteModal(false);
    } else {
      toast.error(deleteCustomerUrlLinkTypeResponseAPI?.message);
    }
    dispatch(deleteCustomerURLLinkTypeSuccess([]));
  }, [deleteCustomerUrlLinkTypeResponseAPI]);

  //Create Acquisition Channel response
  useEffect(() => {
    if (isEmpty(createAcquisitionChannelSuccessAPI)) return;
    if (createAcquisitionChannelSuccessAPI?.status === 200) {
      toast.success(createAcquisitionChannelSuccessAPI?.message);
      dispatch(getAcquisitionChannelList());
    } else {
      toast.error(createAcquisitionChannelSuccessAPI?.message);
    }
    dispatch(createAcquisitionChannelSuccess([]));
  }, [createAcquisitionChannelSuccessAPI]);

  //Update Acquisition Channel response
  useEffect(() => {
    if (isEmpty(updateAcquisitionChannelSuccessAPI)) return;
    if (updateAcquisitionChannelSuccessAPI?.status === 200) {
      toast.success(updateAcquisitionChannelSuccessAPI?.message);
      dispatch(getAcquisitionChannelList());
    } else {
      toast.error(updateAcquisitionChannelSuccessAPI?.message);
    }
    dispatch(updateAcquisitionChannelSuccess([]));
  }, [updateAcquisitionChannelSuccessAPI]);

  //Delete Acquisition Channel response
  useEffect(() => {
    if (isEmpty(deleteAcquisitionChannelSuccessAPI)) return;
    if (deleteAcquisitionChannelSuccessAPI?.status === 200) {
      toast.success(deleteAcquisitionChannelSuccessAPI?.message);
      dispatch(getAcquisitionChannelList());
      setDeleteModal(false);
    } else {
      toast.error(deleteAcquisitionChannelSuccessAPI?.message);
    }
    dispatch(deleteAcquisitionChannelSuccess([]));
  }, [deleteAcquisitionChannelSuccessAPI]);

  //Create External Identification Provider response
  useEffect(() => {
    if (
      isEmpty(
        createSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI
      )
    )
      return;
    if (
      createSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI?.status ===
      200
    ) {
      toast.success(
        createSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI?.message
      );
      dispatch(
        getSingleCustomerExternalIDsExternalIdentificationProviderListData()
      );
    } else {
      toast.error(
        createSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI?.message
      );
    }
    dispatch(
      createSingleCustomerExternalIDsExternalIdentificationProviderSuccess([])
    );
  }, [
    createSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI,
  ]);

  //Update External Identification Provider response
  useEffect(() => {
    if (
      isEmpty(
        updateSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI
      )
    )
      return;
    if (
      updateSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI?.status ===
      200
    ) {
      toast.success(
        updateSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI?.message
      );
      dispatch(
        getSingleCustomerExternalIDsExternalIdentificationProviderListData()
      );
    } else {
      toast.error(
        updateSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI?.message
      );
    }
    dispatch(
      updateSingleCustomerExternalIDsExternalIdentificationProviderSuccess([])
    );
  }, [
    updateSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI,
  ]);

  //Delete External Identification Provider response
  useEffect(() => {
    if (
      isEmpty(
        deleteSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI
      )
    )
      return;
    if (
      deleteSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI?.status ===
      200
    ) {
      toast.success(
        deleteSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI?.message
      );
      dispatch(
        getSingleCustomerExternalIDsExternalIdentificationProviderListData()
      );
      setDeleteModal(false);
    } else {
      toast.error(
        deleteSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI?.message
      );
    }
    dispatch(
      deleteSingleCustomerExternalIDsExternalIdentificationProviderSuccess([])
    );
  }, [
    deleteSingleCustomerExternalIdsExternalIdentificationProviderResponseAPI,
  ]);

  //Create Customer Status response
  useEffect(() => {
    if (isEmpty(createCustomerStatusResponseAPI)) return;
    if (createCustomerStatusResponseAPI?.status === 200) {
      toast.success(createCustomerStatusResponseAPI?.message);
      dispatch(getCustomerStatusListData());
    } else {
      toast.error(createCustomerStatusResponseAPI?.message);
    }
    dispatch(createCustomerStatusSuccess([]));
  }, [createCustomerStatusResponseAPI]);

  //Update Customer Status response
  useEffect(() => {
    if (isEmpty(updateCustomerStatusResponseAPI)) return;
    if (updateCustomerStatusResponseAPI?.status === 200) {
      toast.success(updateCustomerStatusResponseAPI?.message);
      dispatch(getCustomerStatusListData());
    } else {
      toast.error(updateCustomerStatusResponseAPI?.message);
    }
    dispatch(updateCustomerStatusSuccess([]));
  }, [updateCustomerStatusResponseAPI]);

  //Delete Customer Status response
  useEffect(() => {
    if (isEmpty(deleteCustomerStatusResponseAPI)) return;
    if (deleteCustomerStatusResponseAPI?.status === 200) {
      toast.success(deleteCustomerStatusResponseAPI?.message);
      dispatch(getCustomerStatusListData());
      setDeleteModal(false);
    } else {
      toast.error(deleteCustomerStatusResponseAPI?.message);
    }
    dispatch(deleteCustomerStatusSuccess([]));
  }, [deleteCustomerStatusResponseAPI]);

  //Create Customer Type response
  useEffect(() => {
    if (isEmpty(createCustomerTypeResponseAPI)) return;
    if (createCustomerTypeResponseAPI?.status === 200) {
      toast.success(createCustomerTypeResponseAPI?.message);
      dispatch(getCustomerTypeListData());
    } else {
      toast.error(createCustomerTypeResponseAPI?.message);
    }
    dispatch(createCustomerTypeSuccess([]));
  }, [createCustomerTypeResponseAPI]);

  //Update Customer Type response
  useEffect(() => {
    if (isEmpty(updateCustomerTypeResponseAPI)) return;
    if (updateCustomerTypeResponseAPI?.status === 200) {
      toast.success(updateCustomerTypeResponseAPI?.message);
      dispatch(getCustomerTypeListData());
    } else {
      toast.error(updateCustomerTypeResponseAPI?.message);
    }
    dispatch(updateCustomerTypeSuccess([]));
  }, [updateCustomerTypeResponseAPI]);

  //Delete Customer Type response
  useEffect(() => {
    if (isEmpty(deleteCustomerTypeResponseAPI)) return;
    if (deleteCustomerTypeResponseAPI?.status === 200) {
      toast.success(deleteCustomerTypeResponseAPI?.message);
      dispatch(getCustomerTypeListData());
      setDeleteModal(false);
    } else {
      toast.error(deleteCustomerTypeResponseAPI?.message);
    }
    dispatch(deleteCustomerTypeSuccess([]));
  }, [deleteCustomerTypeResponseAPI]);
  return (
    <>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteStatus}
        onCloseClick={() => {
          setDeleteModal(false);
        }}
      />
      <SettingsPanel
        title="Customer Settings"
        description="Statuses, types and acquisition channels for customers"
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        {activeTab === "4" && (
          <div className="d-flex justify-content-end mb-3">
            <Link
              to="/reports/customer-identifications"
              className="btn btn-soft-primary"
            >
              <i className="fa-solid fa-list-ul me-2"></i>
              View all customer identifications
            </Link>
          </div>
        )}
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
          config={
            activeTab === "4"
              ? {
                  name: "MasterExternalIdentificationProvider",
                  data: masterProvidersList,
                }
              : undefined
          }
        />
      </SettingsPanel>
    </>
  );
}
